import React, { useState } from "react";
import { Box, ButtonBase, Paper, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SmallModal from "./modals/SmallModal";

/**
 * Tarjeta del menú de reportes: toda la tarjeta es un botón que abre el selector
 * del reporte en un modal.
 */
const CallerSelector = ({ icon, text, modalTitle, children }) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <Paper
      sx={{
        height: "100%",
        transition: (theme) =>
          theme.transitions.create("border-color", { duration: 150 }),
        "&:hover": { borderColor: "primary.main" },
      }}
    >
      <ButtonBase
        onClick={() => setShowModal(true)}
        aria-label={text}
        aria-haspopup="dialog"
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: 1.5,
          p: 2.5,
          borderRadius: "inherit",
          textAlign: "center",
          "&:hover": { bgcolor: "action.hover" },
        }}
      >
        <Box
          component="span"
          aria-hidden="true"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 72,
            height: 72,
            borderRadius: "50%",
            bgcolor: (theme) => theme.palette.soft?.primary,
            color: "primary.main",
          }}
        >
          <FontAwesomeIcon icon={icon} style={{ width: 32, height: 32 }} />
        </Box>
        <Typography
          variant="subtitle1"
          component="span"
          sx={{ fontWeight: 700, color: "text.primary" }}
        >
          {text}
        </Typography>
      </ButtonBase>
      <SmallModal
        titulo={modalTitle}
        isVisible={showModal}
        setVisible={setShowModal}
      >
        {children}
      </SmallModal>
    </Paper>
  );
};

export default CallerSelector;
